<div class="toast-container position-fixed top-0 end-0 p-3">
  @for (toast of toasts; track toast) {
    <ngb-toast
      class="align-items-center border-0"
      [ngClass]="toast.backgroundClass"
      [autohide]="true"
      [delay]="5000"
      (hidden)="removeToast(toast)"
      role="alert"
      aria-live="assertive"
      aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body d-flex align-items-center">
          <div class="pe-3">
            @if (toast.type === AlertType.SUCCESS) {
              <fa-icon [icon]='["fas", "circle-check"]'></fa-icon>
            }
            @if (toast.type === AlertType.WARNING) {
              <fa-icon [icon]='["fas", "exclamation-triangle"]'></fa-icon>
            }
            @if (toast.type === AlertType.ERROR) {
              <fa-icon [icon]='["fas", "times-circle"]'></fa-icon>
            }
            @if (toast.type === AlertType.INFO) {
              <fa-icon [icon]='["fas", "exclamation-circle"]'></fa-icon>
            }
          </div>
          <span [innerHTML]="toast.message"></span>
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" (click)="removeToast(toast)" aria-label="Close"></button>
      </div>
    </ngb-toast>
  }
</div>
